import { PAYMENT_METHODS, PaymentProviders } from "@/constants/payment";
import { PricePlansIds } from "@/constants/prices";
import { localStorageManager, LocalStorageManagerKeys } from "@/utils/localStorageManager";
import { PricePoint } from "@palta-brain/payments";

export enum PaymentActions {
    SET_IDENT = "set_ident",
    SET_PAYMENT_METHOD = "set_payment_method",
    SET_PAYMENT_COMPLETE = "set_payment_complete",
    SET_PAYMENT_ERROR = "set_payment_error",
    SET_PAYMENT_PENDING = "set_payment_pending",
    SET_PAYPAL_PAYMENT_LOADING = "set_paypal_payment_loading",
    SET_IS_PAYMENT_FORM_INITIALISED = "set_is_payment_form_initialised",
    SET_IS_PAYMENT_FORM_INITIALISING = "set_is_payment_form_initialising",
    SET_IS_CLIENT_INITIALISED = "set_is_client_initialised",
    SET_PRICE_POINTS = "set_price_points",
}

export interface PaymentType {
    ident?: PricePlansIds | null;
    pricePoints?: PricePoint[];
    isPaymentError?: boolean;
    isPaymentComplete?: boolean;
    paymentMethod?: PAYMENT_METHODS;
    isPaymentPending?: boolean;
    isPaypalPaymentLoading?: boolean;
    isClientInitialised?: boolean;
    isPaymentFormInitialised?: boolean;
    isPaymentFormInitialising?: boolean;
    provider?: PaymentProviders | null;
}

export interface PaymentAction extends PaymentType {
    type: PaymentActions;
}

export const defaultPaymentState: PaymentType = {
    ident: localStorageManager.getStoredItem<PricePlansIds>(
        LocalStorageManagerKeys.BOUGHT_PLAN_IDENT
    ),
    isPaymentComplete: false,
    isPaymentError: false,
    paymentMethod: PAYMENT_METHODS.APPLE,
    isPaymentPending: false,
    isPaypalPaymentLoading: false,
    isPaymentFormInitialised: false,
    isClientInitialised: false,
    isPaymentFormInitialising: false,
    provider: null,
};

export const paymentReducer = (state: PaymentType, action: PaymentAction): PaymentType => {
    const reducer = {
        [PaymentActions.SET_IDENT]: {
            ...state,
            ident: action.ident,
        },
        [PaymentActions.SET_PAYMENT_COMPLETE]: {
            ...state,
            isPaymentComplete: action.isPaymentComplete,
        },
        [PaymentActions.SET_PAYMENT_ERROR]: {
            ...state,
            isPaymentError: action.isPaymentError,
        },
        [PaymentActions.SET_PAYMENT_METHOD]: {
            ...state,
            paymentMethod: action.paymentMethod,
        },
        [PaymentActions.SET_PAYMENT_PENDING]: {
            ...state,
            isPaymentPending: action.isPaymentPending,
        },
        [PaymentActions.SET_PAYPAL_PAYMENT_LOADING]: {
            ...state,
            isPaypalPaymentLoading: action.isPaypalPaymentLoading,
        },
        [PaymentActions.SET_IS_PAYMENT_FORM_INITIALISED]: {
            ...state,
            isPaymentFormInitialised: action.isPaymentFormInitialised,
            provider: action.provider,
        },
        [PaymentActions.SET_PRICE_POINTS]: {
            ...state,
            pricePoints: action.pricePoints,
        },
        [PaymentActions.SET_IS_CLIENT_INITIALISED]: {
            ...state,
            isClientInitialised: action.isClientInitialised,
        },
        [PaymentActions.SET_IS_PAYMENT_FORM_INITIALISING]: {
            ...state,
            isPaymentFormInitialising: action.isPaymentFormInitialising,
            ident: action.ident,
        },
    };
    const newState = reducer[action.type];

    if (newState) {
        return newState;
    }

    throw Error("Unknown payment action: " + action.type);
};
